import pageTranslations from './en/index.js';

function unwrapMessages(moduleValue) {
    let value = moduleValue;

    while (value && typeof value === 'object' && 'default' in value) {
        value = value.default;
    }

    return value && typeof value === 'object' ? value : {};
}

const pages = unwrapMessages(pageTranslations);

export default {
    ...pages,
    welcome: {
        title: 'ShipToMarket | Validate your business idea with AI and real leads',
        description:
            'Get market, TAM, SAM and viability analysis, then run real lead tests before you invest.',
        login: 'Login',
        register: 'Register',
        contact: 'Contact',
        about: 'About',
        features: 'Features',
    },
    common: {
        save: 'Save',
        cancel: 'Cancel',
        next: 'Next',
        back: 'Back',
        loading: 'Loading...',
        error: 'An error occurred',
        optional: 'Optional',
        getCredits: 'Get Credits',
    },
    errors: {
        404: {
            title: 'Page Not Found',
            heading: 'Page Not Found',
            message: 'The page you are looking for does not exist or has been moved.',
            goToDashboard: 'Go to Dashboard',
            goToHome: 'Go to Home',
        },
        419: {
            title: 'Session Expired',
            heading: 'Session Expired',
            message: 'Your session has expired. Please reload the page to continue.',
            reloadPage: 'Reload Page',
            goToDashboard: 'Go to Dashboard',
            goToHome: 'Go to Home',
        },
        500: {
            title: 'Server Error',
            heading: 'Something Went Wrong',
            message: 'We are experiencing technical difficulties. Please try again later.',
            goToDashboard: 'Go to Dashboard',
            goToHome: 'Go to Home',
        },
        503: {
            title: 'Service Unavailable',
            heading: 'Under Maintenance',
            message: 'We are currently performing maintenance. Please check back soon.',
        },
    },
};
